(function() {
    'use strict';
    angular
        .module('telestatApp')
        .factory('DivisionConversionReport', DivisionConversionReport);

    DivisionConversionReport.$inject = ['$resource'];

    function DivisionConversionReport ($resource) {
        var resourceUrl =  'api/report/division-conversion/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
